<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="workflow-cho-title" :field="fields?.title" tag="h2" />
      <div class="workflow-cho-content" v-if="fields?.stepList?.length > 0">
        <div class="workflow-cho-content-card">
          <div
            class="workflow-cho-content-card-item"
            v-for="item in filteredStepList"
            :key="item?.id"
          >
            <JssRichText
              class="workflow-cho-content-card-item-card"
              :field="item?.fields?.cardText"
              tag="h3"
            />
          </div>
        </div>
        <div class="workflow-cho-content-list" v-if="fields?.stepList?.length > 0">
          <div class="workflow-cho-content-list-line"></div>
          <div
            class="workflow-cho-content-list-item"
            v-for="item in fields?.stepList"
            :key="item?.id"
          >
            <div class="workflow-cho-content-list-item-content">
              <AdaptiveImage
                class="workflow-cho-content-list-item-content-icon"
                :field="item.fields?.icon"
                :isBackground="false"
                :lazy-load="false"
                :enableScrollDetection="false"
                :show="true"
                v-if="item.fields?.icon"
              />
              <div class="workflow-cho-content-list-item-content-bg" v-else>
                <div
                  class="workflow-cho-content-list-item-content-bg-inner"
                  :style="{ background: item.fields?.stepBgColor?.value }"
                ></div>
              </div>
            </div>
            <JssRichText
              class="workflow-cho-content-list-item-text"
              :field="item?.fields?.stepText"
            />
            <JssRichText
              class="workflow-cho-content-list-item-linetext"
              :field="item?.fields?.lineText"
            />
          </div>
        </div>
      </div>
      <div class="workflow-cho-cardbg" v-if="fields?.cardList?.length > 0">
        <div class="workflow-cho-card">
          <div class="workflow-cho-card-item" v-for="item in fields?.cardList" :key="item?.id">
            <JssRichText
              class="workflow-cho-card-item-title"
              :field="item?.fields?.cardTitle"
              tag="h3"
            />
            <JssRichText class="workflow-cho-card-item-desc" :field="item?.fields?.cardDesc" />
          </div>
        </div>
        <JssRichText class="workflow-cho-footer" :field="fields?.footerText" />
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'WorkflowCho',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'workflow-cho'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    const filteredStepList = computed(() => {
      return (props.fields?.stepList || []).filter((item) => item?.fields?.cardText?.value);
    });

    return {
      rootClass,
      rootStyle,
      filteredStepList,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.workflow-cho {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow-x: auto;
    min-height: 240px;

    &::-webkit-scrollbar {
      display: none;
    }

    &-card {
      margin-top: 24px;
      display: flex;
      justify-content: flex-end;
      gap: 50px;
      width: 1135px;
      padding: 0 20px 0 120px;

      &-item {
        flex: 1;

        &:last-child {
          flex: 1.5;
        }

        &-card {
          height: 46px;
          background-color: #abbcac;
          border-radius: 4px;
          padding: 0 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          line-height: 1.4;
          color: $white;
          text-align: center;
        }
      }
    }

    &-list {
      margin-top: 10px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 0 50px;
      width: 1135px;
      position: relative;

      &-line {
        position: absolute;
        top: 31px;
        left: 0;
        transform: translateY(-50%);
        width: 100%;
        height: 1px;
        background-color: #abbcac;
      }

      &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        min-width: 92px;
        z-index: 2;

        &-content {
          &-icon {
            width: 62px;
            height: 62px;
          }
          &-bg {
            width: 62px;
            height: 62px;
            display: flex;
            align-items: center;
            justify-content: center;

            &-inner {
              width: 28px;
              height: 28px;
              border-radius: 100%;
            }
          }
        }

        &-text {
          font-size: 20px;
          line-height: 1.4;
          color: $grey-black;
          margin-top: 24px;
        }

        &-linetext {
          font-size: 14px;
          line-height: 1.2;
          color: $grey-black;
          position: absolute;
          top: 40px;
          left: 110px;
        }
      }
    }
  }

  &-cardbg {
    background-color: #f6faf9;
    border-radius: 16px;
    margin-top: 30px;
    padding: 30px;
  }

  &-card {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background-color: $white;
      border-radius: 16px;
      padding: 24px;

      &-title {
        font-size: 18px;
        line-height: 1.2;
        font-weight: 700;
        color: $grey-black;
      }

      &-desc {
        flex: 1;
        padding: 16px;
        font-size: 14px;
        line-height: 1.2;
        color: $grey-black;
        background: rgba($blue-night, 0.1);
        margin-top: 16px;
      }
    }
  }

  &-footer {
    font-size: 24px;
    line-height: 1.2;
    color: $grey-black;
    font-weight: 700;
    margin-top: 24px;
    text-align: center;
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-title {
      font-size: 32px;
      line-height: 60px;
    }

    &-content {
      &-card {
        width: 100%;
      }

      &-list {
        width: 100%;

        &-item {
          &-linetext {
            left: 90px;
            width: 120px;
          }
        }
      }
    }

    &-card {
      flex-direction: row;
    }
  }
}
</style>
